import React from 'react';
import { Row, Col, Form, Image } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import FormInput from '../form/FormInput';
import FormSelect from '../form/FormSelect'; // Assuming this is your generic FormSelect
// import './StepProjectDetails.css';

const StepProjectDetails = ({ control, errors, lookupOptions, existingImageUrl, startDateValue, endDateValue }) => (
    <div className="projectDetails animate-fade-in">
        <div className="form-section-title">Core Information</div>
        <Row>
            <Col md={3}><FormSelect name="project_type" label="Project Type" control={control} errors={errors} options={lookupOptions.project_type} isRequired isMulti={false} /></Col> {/* Explicitly isMulti={false} */}
            <Col md={3}><FormInput name="project_name" label="Project Name" control={control} errors={errors} isRequired /></Col>
            <Col md={3}><FormSelect name="program_language" label="Language" control={control} errors={errors} options={lookupOptions.program_language} isMulti isRequired /></Col>
            <Col md={3}><FormInput name="director_name" label="Director Name" control={control} errors={errors} isRequired /></Col>
        </Row>

        <Row>
            <Col md={3}>
                <Form.Group className="mb-4">
                    <Form.Label className="form-label">Start Date <span className="text-danger">*</span></Form.Label>
                    <Controller name="start_date" control={control} render={({ field }) => (
                        <DatePicker selected={field.value} onChange={(date) => field.onChange(date)} maxDate={endDateValue || null} dateFormat="dd/MM/yyyy" placeholderText="Select Start Date" className="custom-form-input" autoComplete="off" showMonthDropdown showYearDropdown dropdownMode="select" />
                    )} />
                    {errors.start_date && <div className="text-danger small mt-1">{errors.start_date.message}</div>}
                </Form.Group>
            </Col>
            <Col md={3}>
                <Form.Group className="mb-4">
                    <Form.Label className="form-label">End Date <span className="text-danger">*</span></Form.Label>
                    <Controller name="end_date" control={control} render={({ field }) => (
                        <DatePicker selected={field.value} onChange={(date) => field.onChange(date)} minDate={startDateValue || new Date()} dateFormat="dd/MM/yyyy" placeholderText="Select End Date" className="custom-form-input" autoComplete="off" showMonthDropdown showYearDropdown dropdownMode="select" />
                    )} />
                    {errors.end_date && <div className="text-danger small mt-1">{errors.end_date.message}</div>}
                </Form.Group>
            </Col>
            <Col md={3}><FormInput name="producer_name" label="Producer Name" control={control} errors={errors} isRequired /></Col>
            <Col md={3}><FormSelect name="preferred_shoot_country" label="Shoot Country" control={control} errors={errors} options={lookupOptions.preferred_shoot_country} isMulti isClearable isRequired placeholder="Select Country" /></Col>
        </Row>

        <div className="form-section-title">Additional Details</div>
        <Row>
            <Col md={3}><FormInput name="telecast_channel" label="Telecast Channel" control={control} errors={errors}/></Col>
            <Col md={3}><FormSelect name="type_of_genres" label="Genres" control={control} errors={errors} options={lookupOptions.type_of_genres} isMulti isClearable placeholder="Select Genres" /></Col>
            <Col md={3}>
                <Form.Group className="mb-4">
                    <Form.Label className="form-label">Banner Image</Form.Label>
                    <div className="d-flex align-items-center gap-2 border border-secondary rounded p-1" style={{ background: '#212529', minHeight: '45px', border: '1px solid #495057' }}>
                        <Controller name="synopsis_upload" control={control} render={({ field }) => (
                            <Form.Control type="file" onChange={e => field.onChange(e.target.files)} className="border-0 bg-transparent text-white shadow-none h-auto p-2" style={{ fontSize: '12px' }} />
                        )}/>
                        {existingImageUrl && <Image src={existingImageUrl} rounded style={{ width: '45px', height: '35px', objectFit: 'cover', border: '1px solid #b7343a' }} />}
                    </div>
                </Form.Group>
            </Col>
        </Row>
        <FormInput name="more_details" label="More Details" as="textarea" rows={5} control={control} errors={errors} />
    </div>
);

export default StepProjectDetails;